const mapValues_ = require('lodash/mapValues')

const { assertDatasetTypeIsRouter } = require('./datasetApiAssertions')

const routerDatasetApiCreator = ({ recordStore, getState, datasetType }) => {
  const routerDatasetApi = {
    async getNextDynamicPage() {
      return await recordStore().matchWith({
        Nothing: () => null,
        Just: ({ value: service }) => {
          return service.getNextDynamicPage()
        }
      })
    },

    async getPreviousDynamicPage() {
      return await recordStore().matchWith({
        Nothing: () => null,
        Just: ({ value: service }) => {
          return service.getPreviousDynamicPage()
        }
      })
    }
  }
  return mapValues_(routerDatasetApi, (fn, functionName) => (...args) => {
    assertDatasetTypeIsRouter(datasetType, functionName)
    return fn(...args)
  })
}

module.exports = routerDatasetApiCreator



// WEBPACK FOOTER //
// ./dataset-controller/routerDatasetApi.js